import MyAxios from "@/api/axios"
import axios, { AxiosResponse } from 'axios'
import { IInvoiceBillCycle } from '@/interface/services'
import { ICostCenterDTO, IInvoiceDTO, IInvoiceSituationDTO, IRequestDTO } from "@/interface"
import { InvoiceSituation } from "@/models/invoice/situation"
import { Invoice } from "@/models/invoice/invoice"
import { Invoices } from "@/models/invoice/invoices"
import { useCustomerStore } from "@/stores/customer"
import { getCustomerStore } from "@/helpers/storeHelpers"

export const getBillCycleById = async (id: number): Promise<IInvoiceBillCycle> => {
    return await MyAxios.get<IInvoiceBillCycle|void>(`/invoices/bill-cycle/${id}`, { ignoreGlobalLoader: true })
        .then((response:AxiosResponse<IInvoiceBillCycle|any>) => {
            return response.data;
        })
}

export const getInvoice = async (
        isPaid = false,
        customerRef: number | null = null
        ): Promise<Invoices | null> => {
    const customerId = customerRef ?? getCustomerStore()?.id ?? null
    const paramInvoice = isPaid ? 'paid' : 'open';
    const url = `/customer/${customerId}/invoices/${paramInvoice}`;

    return await MyAxios.get(url).then(
        (response:AxiosResponse<IRequestDTO<IInvoiceDTO>>) => Invoices.fromDto(response.data, isPaid)
    );
}

export const getCostCenters = async (
        customerRef: number | null = null
    ): Promise<ICostCenterDTO[] | null> => {
    const customerId = customerRef ?? getCustomerStore()?.id ?? null
    const url = `/customer/${customerId}/cost-centers`;

    return await MyAxios.get(url).then(
        (response:AxiosResponse<ICostCenterDTO[]>) => response.data
    );
}

export const AllGetInvoice = async () => {
    return await axios.all([getInvoice(), getInvoice(true)])
        .then(axios.spread(function (invoice, invoiceHistory) {
        return {invoice, invoiceHistory};
    }));
}

export const getInvoiceSituation = async (
        customerRef: number | null = null
    ): Promise<InvoiceSituation | null> => {
    const customerId = customerRef ?? getCustomerStore()?.id ?? null
    const url = `/customer/${customerId}/invoices/situation`;

    return await MyAxios.get(url, { ignoreGlobalLoader: true }).then(
        (response:AxiosResponse<IInvoiceSituationDTO>) => InvoiceSituation.fromDto(response.data)
    );
}

export const getInvoiceFilePdf = async (
        data: Invoice, 
        customerRef: number | null = null) => {
    const customerId = customerRef ?? getCustomerStore()?.id ?? null
    const url = `/customer/${customerId}/invoices/${data.invoiceUuid}/download`;

    return await MyAxios.get(url, {
        responseType: 'blob',
        headers: {
            "Accept": "application/pdf, application/json",
        }
    }).then((response) => response);
}
